import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import ServiceArea from "@/pages/ServiceArea";
import ReviewsPage from "@/pages/ReviewsPage";
import GetHelp from "@/pages/GetHelp";
import Follow from "@/pages/Follow";
import Track from "@/pages/Track";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/service-area" element={<ServiceArea />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/get-help" element={<GetHelp />} />
          <Route path="/follow" element={<Follow />} />
          <Route path="/track/:id" element={<Track />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.12)", color: "#F5F5F5", borderRadius: 0 } }}
      />
    </div>
  );
}

export default App;
